// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"if_a bhc_je","CommentListPlaceholder--Legacy":"if_b bhc_qh bhc_vk"};